import React from "react";
import Utils from "Utils/utils";
import { observer } from "mobx-react";
import { linkedInReplyState } from "./state";

const ReconnectLinkedInButton = observer((props = {}) => {
  const { accountId = "" } = props;
  return (
    <div className="btnInboxActions">
      <span
        className="reconnectBtn"
        onClick={e => {
          Utils.preventDefaultFn(e);
          linkedInReplyState.reconnectLinkedInViaOAuth(accountId);
        }}
      >
        Reconnect
      </span>
    </div>
  );
});

export default ReconnectLinkedInButton;
